export const THEMES = ['night', 'ice', 'jets', 'chargers'] as const;

export type BoardTheme = (typeof THEMES)[number];

export const THEME_KEY = 'pickem:board-theme';

const THEME_COLOR: Record<BoardTheme, string> = {
  night: '#091833',
  ice: '#01012b',
  jets: '#000000',
  chargers: '#002032',
};

function isTheme(raw: string | null | undefined): raw is BoardTheme {
  return (THEMES as readonly string[]).includes(raw ?? '');
}

export function parseTheme(raw: string | null | undefined): BoardTheme {
  return isTheme(raw) ? raw : 'night';
}

export function applyTheme(theme: BoardTheme): void {
  document.documentElement.dataset.theme = theme;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', THEME_COLOR[theme]);
  try {
    localStorage.setItem(THEME_KEY, theme);
  } catch {
  }
}

export function loadTheme(): BoardTheme {
  try {
    return parseTheme(localStorage.getItem(THEME_KEY));
  } catch {
    return 'night';
  }
}
